import { defaultBillingAddressStyles } from "@insite/content-library/Widgets/AccountSettings/DefaultBillingAddress";
import { css } from "styled-components";

Object.assign(defaultBillingAddressStyles, {
    ...defaultBillingAddressStyles,
    customerSelectorModalCancelButton: {
        css: css`
            background-color: #999;
            border: none;
            :hover {
                background-color: #999;
            }
        `,
    },
});
